$(document).on("change", ".btn-choose-file-other-service", function () {
  const files = this.files;
  const length = files.length;
  let invalid = false;
  for (let i = 0; i < length; i++) {
    const maxSize = 10 * 1024 * 1024;
    // Check file type - only allow images
    if (!files[i].type.startsWith('image/')) {
      invalid = true;
      break;
    }
    // Check file size
    if (files[i].size > maxSize) {
      invalid = true;
    }
  }
  if (invalid) {
    $("body").append(`
        <div class="modal fade" id="image_modal" data-bs-backdrop="true" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
          <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <div class="content-madal-text d-flex justify-content-center fw-bold px-3">
                  画像ファイルのみ10MBサイズ以下でアップお願いします。
                </div>
              </div>
            </div>
          </div>
        </div>
      `);
    $("#image_modal").show();
    $("#image_modal").addClass("show");
    $(document).on("click", "#image_modal button", function () {
      $("#image_modal").remove();
    });
    this.value = "";
    $(".preview-wrapper").find(".image-wrapper").empty();
    return;
  }
  imagesPreview(this, $(".preview-wrapper").find(".image-wrapper"));
  imagesPreview(this, $(".hospital-images"));
});

var imagesPreview = function (input, placeToInsertImagePreview) {
  if (input.files.length < 6) {
    placeToInsertImagePreview.empty();
    var filesAmount = input.files.length;
    for (let i = 0; i < filesAmount; i++) {
      var reader = new FileReader();

      reader.onload = function (event) {
        let htmlImagePreview = `<div class="pb-4 col-6 col-lg-4 col-xl-3 col-xxl-2">
                    <img src="${event.target.result}" width="140px" height="140px">
                  </div>`;
        $(htmlImagePreview).appendTo(placeToInsertImagePreview);
      };
      reader.readAsDataURL(input.files[i]);
    }
  }
};

$(document).on("change", ".btn-choose-file-other-service", function () {
  const file = document.querySelector(".btn-choose-file-other-service");
  const fileName = document.getElementById("file-name");
  const maxChars = 20;

  const selectedFile = file.files[0];
  let text = "";
  if (selectedFile) {
    if (file.files.length > 5) {
      $(".file-error").removeClass("d-none");
      $("#file-file").val("");
      $(".cm_input_file_text").text("※最大10MBまでアップできます。");
    } else if (file.files.length > 1) {
      fileName.textContent = `${file.files.length}つのファイル`;
      $(".file-error").addClass("d-none");
    } else {
      $(".file-error").addClass("d-none");
      text = selectedFile.name;
      text =
        text.length > maxChars
          ? text.substring(0, maxChars / 2) +
            "..." +
            text.substring(text.length - maxChars / 2)
          : text;
      fileName.textContent = text;
    }
  } else {
    fileName.textContent = "※最大10MBまでアップできます。";
  }
});

$(document).on(
  "change",
  "#other_service_publication_date_year, #other_service_publication_date_month",
  function () {
    let year = $("#other_service_publication_date_year").val();
    let month = $("#other_service_publication_date_month").val();
    let day = $("#other_service_publication_date_day").val();
    const date = new Date(year, month - 1, 1);
    const days = [];

    while (date.getMonth() === month - 1) {
      days.push(date.getDate());
      date.setDate(date.getDate() + 1);
    }
    let options = '<option value="">—</option>';
    days.forEach((e) => {
      options = options.concat(
        `"<option value="${e}" ${e == day ? "selected" : ""}>${e}</option>"`
      );
    });
    if (year && month) {
      $("#other_service_publication_date_day").html(options);
    } else {
      $("#other_service_publication_date_day").html(
        '<option value="">—</option>'
      );
    }
  }
);

// Handle "その他" checkbox functionality
$(document).ready(function () {
  // Check if "その他" checkbox is checked on page load
  if ($(".other-service-checkbox").is(":checked")) {
    $("#other-service-input").show();
  }

  // Handle "その他" checkbox change
  $(document).on("change", ".other-service-checkbox", function () {
    if ($(this).is(":checked")) {
      $("#other-service-input").show();
    } else {
      $("#other-service-input").hide();
      // Clear the text input when unchecking
      $("#other_service_service_other").val("");
    }
  });
});

// Handle back button click
$(document).on("click", ".btn-back-other-service", function () {
  $(".form-hospital").removeClass("d-none");
  $(".preview-hospital").addClass("d-none");
});

// Handle preview button click function
function handlePreviewClick() {
  let error = "";

  if (!$(".group_img").html().trim()) {
    $(".error-images").removeClass("d-none");
    error = error.concat("写真 、");
  } else {
    $(".error-images").addClass("d-none");
  }

  if (!$("#other_service_name").val()) {
    $(".error-name").removeClass("d-none");
    $("#other_service_name").addClass("input-invalid");
    error = error.concat("事業者名 、");
  } else {
    $(".error-name").addClass("d-none");
    $("#other_service_name").removeClass("input-invalid");
    $(".other-service-name-preview").text($("#other_service_name").val());
  }

  if (!$("#other_service_director").val()) {
    $(".error-director").removeClass("d-none");
    $("#other_service_director").addClass("input-invalid");
    error = error.concat("代表者名 、");
  } else {
    $(".error-director").addClass("d-none");
    $("#other_service_director").removeClass("input-invalid");
    $(".other-service-director-preview").text(
      $("#other_service_director").val()
    );
  }

  if (!$("#pet-prefecture-select").val() || !$("#pet-city-select").val()) {
    $(".error-location").removeClass("d-none");
    $("#pet-prefecture-select").addClass("input-invalid");
    $("#pet-city-select").addClass("input-invalid");
    error = error.concat("住所 、");
  } else {
    $(".error-location").addClass("d-none");
    $("#pet-prefecture-select").removeClass("input-invalid");
    $("#pet-city-select").removeClass("input-invalid");
    $(".other-service-prefecture-preview").text(
      $("#pet-prefecture-select option:selected").text()
    );
    $(".other-service-city-preview").text(
      $("#pet-city-select option:selected").text()
    );
    $(".other-service-addition-location-preview").text(
      $("#other_service_addition_location").val()
    );
  }

  const phoneNumber = $("#other_service_phone_number").val();
  if (!phoneNumber) {
    $(".error-phone-number").removeClass("d-none");
    $("#other_service_phone_number").addClass("input-invalid");
    error = error.concat("電話番号 、");
  } else if (!/^\d{10,11}$/.test(phoneNumber)) {
    $("#phone_number_error").show();
    $("#other_service_phone_number").addClass("input-invalid");
    error = error.concat("電話番号 、");
  } else {
    $(".error-phone-number").addClass("d-none");
    $("#phone_number_error").hide();
    $("#other_service_phone_number").removeClass("input-invalid");
    $(".other-service-phone-number-preview").text(phoneNumber);
  }

  if (!validateEmail($("#other_service_email").val())) {
    $(".error-email-format").removeClass("d-none");
    $("#other_service_email").addClass("input-invalid");
    error = error.concat("メールアドレス 、");
  } else {
    $(".error-email-format").addClass("d-none");
    $("#other_service_email").removeClass("input-invalid");
    $(".other-service-email-preview").text($("#other_service_email").val());
  }

  if (!$(".services").find('input[type="checkbox"]').is(":checked")) {
    $(".error-services").removeClass("d-none");
    error = error.concat("サービス 、");
  } else {
    $(".error-services").addClass("d-none");
    let text = "";
    $(".services")
      .find('input[type="checkbox"]')
      .each(function () {
        if ($(this).is(":checked")) {
          if ($(this).val() !== "その他") {
            text = text.concat($(this).siblings("label").text(), " 、");
          }
        }
      });

    // Add "その他" service if checked and has text
    if (
      $(".other-service-checkbox").is(":checked") &&
      $("#other_service_service_other").val()
    ) {
      text = text.concat(
        "その他: " + $("#other_service_service_other").val(),
        " 、"
      );
    }

    if (text) text = text.slice(0, -1);
    $(".other-service-services-preview").text(text);
  }

  let is_valid_work_schedule = false;
  let invalid_input = [];
  $(".work_schedule input").each(function (index) {
    if (index % 2 === 0) {
      if (
        $(".work_schedule input")[index].value &&
        $(".work_schedule input")[index + 1].value &&
        $(".work_schedule input")[index].value <
          $(".work_schedule input")[index + 1].value
      ) {
        is_valid_work_schedule = true;
      } else {
        invalid_input.push(index, index + 1);
      }
    }
  });

  if (!is_valid_work_schedule) {
    $(".error-work-schedule").removeClass("d-none");
    $(".work_schedule input").removeClass("input-invalid");
    invalid_input.forEach(function (index) {
      if (index % 2 === 0) {
        if (
          !(
            !$(".work_schedule input")[index].value &&
            !$(".work_schedule input")[index + 1].value
          )
        ) {
          $(".work_schedule input")[index].classList.add("input-invalid");
          $(".work_schedule input")[index + 1].classList.add("input-invalid");
        }
      }
    });
    error = error.concat("診察時間 、");
  } else {
    $(".error-work-schedule").addClass("d-none");
    $(".work_schedule input").removeClass("input-invalid");
    $(".work_schedule input").each(function (index) {
      if (index % 2 === 0) {
        let val_1 = $(".work_schedule input")[index].value
          ? $(".work_schedule input")[index].value
          : "—:—";
        let val_2 = $(".work_schedule input")[index + 1].value
          ? $(".work_schedule input")[index + 1].value
          : "—:—";
        let text = val_1 + "~" + val_2;
        $($(".work-schedule-preview")[index / 2]).text(text);
      }
    });
  }

  if (!$("#other_service_notes").val()) {
    $(".error-notes").removeClass("d-none");
    $("#other_service_notes").addClass("input-invalid");
    error = error.concat("紹介内容 、");
  } else {
    $(".error-notes").addClass("d-none");
    $("#other_service_notes").removeClass("input-invalid");
    $(".other-service-notes-preview").text($("#other_service_notes").val());
  }

  if (
    !(
      $("#other_service_publication_date_year").val() &&
      $("#other_service_publication_date_month").val() &&
      $("#other_service_publication_date_day").val()
    )
  ) {
    $(".error-publication-date").removeClass("d-none");
    $("#other_service_publication_date_year").addClass("input-invalid");
    $("#other_service_publication_date_month").addClass("input-invalid");
    $("#other_service_publication_date_day").addClass("input-invalid");
    error = error.concat("掲載希望日 、");
  } else {
    $(".error-publication-date").addClass("d-none");
    $("#other_service_notes").removeClass("input-invalid");
    $("#other_service_publication_date_year").removeClass("input-invalid");
    $("#other_service_publication_date_month").removeClass("input-invalid");
    $("#other_service_publication_date_day").removeClass("input-invalid");
    $(".other-service-publication-date").text(
      $("#other_service_publication_date_year").val() +
        "年 " +
        $("#other_service_publication_date_month").val() +
        "月 " +
        $("#other_service_publication_date_day").val() +
        "日"
    );
  }

  if (error) {
    // Scroll to first error field
    const firstErrorField = $(".input-invalid").first();
    if (firstErrorField.length) {
      $("html, body").animate({
        scrollTop: firstErrorField.offset().top - 100
      }, 500);
      firstErrorField.focus();
    }
  } else {
    // Hide form and show preview exactly like hospital
    $(".form-hospital").addClass("d-none");
    $(".preview-hospital").removeClass("d-none");
    $("html, body").animate({ scrollTop: 0 });
  }
}

const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^([a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)$/
    );
};

// Hide error messages when user starts typing
$(document).on("input", "#other_service_name", function() {
  $(".error-name").addClass("d-none");
  $(this).removeClass("input-invalid");
});

$(document).on("input", "#other_service_director", function() {
  $(".error-director").addClass("d-none");
  $(this).removeClass("input-invalid");
});

$(document).on("change", "#pet-prefecture-select, #pet-city-select", function() {
  $(".error-location").addClass("d-none");
  $("#pet-prefecture-select, #pet-city-select").removeClass("input-invalid");
});

$(document).on("input", "#other_service_phone_number", function() {
  $(".error-phone-number").addClass("d-none");
  $(this).removeClass("input-invalid");
});

$(document).on("input", "#other_service_email", function() {
  $(".error-email-format").addClass("d-none");
  $(this).removeClass("input-invalid");
});

$(document).on("change", ".services input[type='checkbox']", function() {
  $(".error-services").addClass("d-none");
});

$(document).on("input", ".work_schedule input", function() {
  $(".error-work-schedule").addClass("d-none");
});

$(document).on("input", "#other_service_notes", function() {
  $(".error-notes").addClass("d-none");
  $(this).removeClass("input-invalid");
});

$(document).on("change", "#other_service_publication_date_year, #other_service_publication_date_month, #other_service_publication_date_day", function() {
  $(".error-publication-date").addClass("d-none");
});

// Hide image error when files are selected
$(document).on("change", ".btn-choose-file-other-service", function() {
  if (this.files.length > 0) {
    $(".error-images").addClass("d-none");
  }
});

// Phone number validation
$(document).on("input", "#other_service_phone_number", function() {
  const phoneNumber = $(this).val();
  const phoneError = $("#phone_number_error");
  const requiredError = $(".error-phone-number");
  
  // Hide both error messages first
  phoneError.addClass("d-none");
  requiredError.addClass("d-none");
  $(this).removeClass("input-invalid");
  
  // Show appropriate error message
  if (phoneNumber === "") {
    // Empty phone number - show required error
    requiredError.removeClass("d-none");
    $(this).addClass("input-invalid");
  } else if (!/^\d{10,11}$/.test(phoneNumber)) {
    // Invalid format - show format error
    phoneError.removeClass("d-none");
    $(this).addClass("input-invalid");
  }
});

// Function to initialize other service functionality
function initializeOtherService() {
  $(".btn-preview-other-service").off("click");
  $(".btn-preview-other-service").on("click", function (e) {
    console.log("Preview button clicked!");
    e.preventDefault();
    e.stopPropagation();
    handlePreviewClick();
  });

  // Admin delete other service functionality
  $(".modal-admin-destroy-other-service").on("click", function (e) {
    var id = $(this).data("id");
    var owner_id = $(this).data("owner");
    console.log("Admin deleting OtherService:", id, owner_id);

    $.ajax({
      url: "/admin/other_services/" + id,
      method: "DELETE",
      data: { id: id, owner_id: owner_id },
      dataType: "json",
      success: function (response) {
        if (response.success) {
          $("#staticBackdrop-" + id).hide();
          $("#staticBackdrop-" + id).removeClass("show");
          $("#staticBackdrop-" + id).removeAttr("style");
          $("#myModal").addClass("show");
          $("#myModal").show();
        } else {
          window.location.reload();
        }
      },
      error: function (xhr) {
        window.location.reload();
      },
    });
  });

  // User delete other service functionality
  $(".modal-user-destroy-other-service").on("click", function (e) {
    var id = $(this).data("id");
    console.log("User deleting OtherService:", id);

    $.ajax({
      url: "/user/other_services/" + id,
      method: "DELETE",
      data: { id: id },
      dataType: "json",
      success: function (response) {
        if (response.success) {
          $("#staticBackdrop-" + id).hide();
          $("#staticBackdrop-" + id).removeClass("show");
          $("#staticBackdrop-" + id).removeAttr("style");
          $("#myModal").addClass("show");
          $("#myModal").show();
        } else {
          window.location.reload();
        }
      },
      error: function (xhr) {
        window.location.reload();
      },
    });
  });

  // Close modal functionality
  $(".modal-close").on("click", function () {
    $(this).closest(".modal").modal("hide");
  });

  // Close success modal and reload
  $(".close-modal").on("click", function () {
    $("#myModal").modal("hide");
    window.location.reload();
  });
}

// Initialize on document ready
$(document).ready(function () {
  initializeOtherService();
});

// Initialize on turbolinks load
$(document).on("turbolinks:load", function () {
  initializeOtherService();
});

// Also initialize on turbo:load for Rails 7 compatibility
$(document).on("turbo:load", function () {
  initializeOtherService();
});

// Direct event handler for preview button - backup method
$(document).on("click", ".btn-preview-other-service", function (e) {
  console.log("Direct preview button clicked!");
  e.preventDefault();
  e.stopPropagation();
  handlePreviewClick();
});
